module.exports = __webpack_public_path__ + "static/media/tempe-campus.583f8786.jpg";